import { Env } from '@packages/core/config';
import { configService } from '@web/services/singletons';

export const isEvBatteryScan = (): boolean => {
    return (configService.get(Env.EvBatteryScan) || 'OFF').toUpperCase() === 'ON';
};
